/** Icon paths lifted from the approved mockup so the shipped UI matches it. */

interface IconProps {
  size?: number;
  fill?: string;
}

const base = ({ size = 17, fill = 'currentColor' }: IconProps) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill,
});

export const IconOverview = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M11.1 2.8a1.4 1.4 0 0 1 1.8 0l8 6.6c.3.3.5.7.5 1.1v9.3c0 .8-.6 1.4-1.4 1.4h-5V14H8.9v7.2h-5c-.8 0-1.4-.6-1.4-1.4v-9.3c0-.4.2-.8.5-1.1z" />
  </svg>
);

export const IconSchools = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M4 3.6h7.2L14 6.4h6c1.1 0 2 .9 2 2v9.2c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5.6c0-1.1.9-2 2-2z" />
  </svg>
);

export const IconBilling = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M3.6 5.2h16.8c.9 0 1.6.7 1.6 1.6v2H2V6.8c0-.9.7-1.6 1.6-1.6z" />
    <path d="M2 10.8h20v6.4c0 .9-.7 1.6-1.6 1.6H3.6c-.9 0-1.6-.7-1.6-1.6zm13.2 3.6a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z" />
  </svg>
);

export const IconHealth = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M12 2.4a9.6 9.6 0 1 0 0 19.2 9.6 9.6 0 0 0 0-19.2zm4.9 7.3-5.7 6a1.3 1.3 0 0 1-1.9 0L7 13.2a1.3 1.3 0 0 1 1.9-1.8l1.4 1.5 4.8-5a1.3 1.3 0 0 1 1.8 1.8z" />
  </svg>
);

export const IconTickets = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M12 2.4 22.4 20.6H1.6zm-1.2 6v6h2.4v-6zm0 7.6v2.4h2.4V16z" />
  </svg>
);

export const IconUsers = (props: IconProps) => (
  <svg {...base(props)}>
    <circle cx="12" cy="8" r="4" />
    <path d="M12 13.6c-4.3 0-7.6 2.5-7.6 6 0 .9.7 1.6 1.6 1.6h12c.9 0 1.6-.7 1.6-1.6 0-3.5-3.3-6-7.6-6z" />
  </svg>
);

export const IconAudit = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M4.4 3.6h15.2c.9 0 1.6.7 1.6 1.6v14.4c0 .9-.7 1.6-1.6 1.6H4.4c-.9 0-1.6-.7-1.6-1.6V5.2c0-.9.7-1.6 1.6-1.6z" />
  </svg>
);

export const IconSearch = (props: IconProps) => (
  <svg {...base(props)}>
    <path d="M10.5 2.4a8.1 8.1 0 1 0 4.9 14.5l4.4 4.4 1.7-1.7-4.4-4.4A8.1 8.1 0 0 0 10.5 2.4zm0 2.4a5.7 5.7 0 1 1 0 11.4 5.7 5.7 0 0 1 0-11.4z" />
  </svg>
);

export const IconPlus = ({ size = 16, fill = 'currentColor' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}>
    <path d="M10.8 3.6h2.4v7.2h7.2v2.4h-7.2v7.2h-2.4v-7.2H3.6v-2.4h7.2z" />
  </svg>
);

export const IconClose = ({ size = 15, fill = 'currentColor' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}>
    <path d="M18.4 7.3 16.7 5.6 12 10.3 7.3 5.6 5.6 7.3 10.3 12l-4.7 4.7 1.7 1.7L12 13.7l4.7 4.7 1.7-1.7L13.7 12z" />
  </svg>
);

export const IconChevron = ({ size = 14, fill = 'currentColor' }: IconProps) => (
  <svg width={(size * 8) / 14} height={size} viewBox="0 0 9 15" fill={fill}>
    <path d="M1.4 0 0 1.5 5 7.5 0 13.5 1.4 15l6.3-7.5z" />
  </svg>
);

export const IconLogout = ({ size = 16, fill = 'currentColor' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill}>
    <path d="M10.8 2.4H5.6c-1.1 0-2 .9-2 2v15.2c0 1.1.9 2 2 2h5.2v-2.4H6V4.8h4.8zm5.2 4.3-1.7 1.7 2.3 2.4H9.6v2.4h7l-2.3 2.4 1.7 1.7 5.2-5.3z" />
  </svg>
);
